import React from 'react';
import { useAgreementTemplateQuery } from '@uplift/queries';
import { CollaborativeAgreementExpiring } from '@uplift/api';
import { ErrorOutline } from '@mui/icons-material';
import { CalendarDateService } from '@uplift/services';
import { DateFormats } from '@uplift/constants';
import { DocumentListItemRow } from './DocumentListItemRow';


export const CollaborativeAgreementExpiringListItem: React.VFC<{
  document: CollaborativeAgreementExpiring;
  onClick: () => void;
  selected: boolean;
}> = ({
  document,
  onClick,
  selected,
}) => {
  const { data: template } = useAgreementTemplateQuery(document.agreementTemplateId);
  const expireAt = CalendarDateService.date(document.expireAt, DateFormats.ISO_DATE).format(DateFormats['MMM D, YYYY']);

  return (
    <DocumentListItemRow
      name={template.name}
      status={`Renew by ${expireAt}`}
      statusColor="warning"
      icon={<ErrorOutline />}
      onClick={onClick}
      selected={selected}
    />
  );
};
